<div class="bk-dialog">
	<button class="bk-modal__close_btn"
        (click)="close()"
        type="button">
        <mat-icon>close</mat-icon>
    </button>

	<h4 mat-dialog-title>
		{{ 'Add' | translate }} {{'Fertilizer(s)' | translate }}
	</h4>

	<div mat-dialog-content>
		<ranch-fertilizer-form #fertilizerForm
			[isRanchAgnostic]="true"
			[selectedFertilizerIds]="selectedFertilizerIds"
			(onCancel)="close()"
			(onSubmit)="submit($event)">
		</ranch-fertilizer-form>
	</div>

	<div mat-dialog-actions align="end">
		<button mat-button
			class="bk-button bk-button--medium
			bk-button--text-only bk-dialog__button--secondary"
			(click)="close()">
			{{'Cancel' | translate }}
		</button>

		<button mat-button
			class="bk-button bk-button--medium"
			*ngIf="fertilizerForm && !fertilizerForm.isCustomFertilizer"
			[disabled]="!fertilizerForm || fertilizerForm.areFertilizersSelected === false"
			(click)="fertilizerForm.submitSelectedFertilizers()">
			{{'Add Selected Fertilizer(s)' | translate }}
		</button>

		<button mat-button
			[disabled]="!fertilizerForm || fertilizerForm.isFormValid === false"
			class="bk-button bk-button--medium"
			*ngIf="fertilizerForm && fertilizerForm.isCustomFertilizer"
			(click)="fertilizerForm.submitCustomFertilizer()">
			{{'Add Custom Fertilizer' | translate }}
		</button>
	</div>
</div>
